/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type EmailSignatureCreateSignatureKind = typeof EmailSignatureCreateSignatureKind[keyof typeof EmailSignatureCreateSignatureKind];


export const EmailSignatureCreateSignatureKind = {
  rich: 'rich',
  template: 'template',
} as const;
